import { createContext, useContext } from "react";
import type { QuickAccessModule } from "./types.js";

export interface QuickAccessCatalog {
  readonly modules: readonly QuickAccessModule[];
}

const Ctx = createContext<QuickAccessCatalog | null>(null);

export const QuickAccessCatalogProvider = Ctx.Provider;

export function useQuickAccessCatalog(): QuickAccessCatalog | null {
  return useContext(Ctx);
}
